module.exports = __webpack_public_path__ + "static/img/card6-10.b53e5b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card6-10.png
// module id = F3v1
// module chunks = 1